import {
  AddressesIcon,
  ContactIcon,
  FacebookIcon,
  InstagramIcon,
  MyParcelsIcon,
  PurchaseAssistantIcon,
  ReferralProgramIcon,
  SettingsIcon,
  TelegramIcon,
  CouponIcon,
} from "@/components/assets/icons";
import { Theme } from "@/enums";

export interface ISidebarMenuItem {
  title: string;
  href?: string;
  icon: React.FC;
  [key: string]: string | React.FC | Theme | undefined;
}

export const sidebarMenuList: ISidebarMenuItem[] = [
  {
    title: "my_parcels",
    href: "/parcels",
    icon: MyParcelsIcon,
  },
  {
    title: "addresses",
    href: "/addresses",
    icon: AddressesIcon,
  },
  {
    title: "referral_program",
    href: "/referral-program",
    icon: ReferralProgramIcon,
  },
  // {
  //   title: "loyality_program",
  //   href: "/loyality-program",
  //   icon: LoyalityProgramIcon,
  // },
  {
    title: "purchase_assistant",
    href: "/purchase-assistant",
    icon: PurchaseAssistantIcon,
  },
  {
    title: "contact",
    href: "/contact",
    icon: ContactIcon,
  },
  {
    title: "coupons",
    href: "/coupons",
    icon: CouponIcon,
  },
  {
    title: "settings",
    href: "/profile/personal-information",
    icon: SettingsIcon,
  },
];

export const sidebarFooterItems: ISidebarMenuItem[] = [
  {
    title: "facebook",
    [Theme.UZ]: "https://www.facebook.com/boxetteuzbekistan",
    [Theme.GEORGIA]: "https://www.facebook.com/boxettegeorgia",
    [Theme.UK]: "https://www.facebook.com/easyxpress",
    icon: FacebookIcon,
  },
  {
    title: "Instagram",
    [Theme.UZ]: "https://www.instagram.com/boxette_uzbekistan/",
    [Theme.GEORGIA]: "https://www.instagram.com/boxettegeorgia/",
    [Theme.UK]: "https://www.instagram.com/easyxpress/",
    icon: InstagramIcon,
  },
  {
    title: "Telegram",
    [Theme.UZ]: "https://t.me/boxette",
    [Theme.GEORGIA]: "",
    [Theme.UK]: "https://web.telegram.org/k/#@easyxpress",
    icon: TelegramIcon,
  },
];
